/** Logs focusin events in dev to trace keyboard focus order across the app. */
import { useEffect } from 'react';

function describeFocusElement(el) {
  if (!el || el === document.documentElement) return null;
  if (el === document.body) return '(body)';

  const parts = [el.tagName.toLowerCase()];
  if (el.id) parts.push(`#${el.id}`);

  const ariaLabel = el.getAttribute('aria-label');
  if (ariaLabel) parts.push(`aria="${ariaLabel}"`);

  const role = el.getAttribute('role');
  if (role) parts.push(`role=${role}`);

  const testId = el.getAttribute('data-testid');
  if (testId) parts.push(`data-testid=${testId}`);

  const className = el.className;
  if (typeof className === 'string' && className) {
    const muiClass = className.split(/\s+/).find((token) => token.startsWith('Mui'));
    if (muiClass) parts.push(muiClass);
  }

  return parts.join(' ');
}

export function useFocusDebugLogger() {
  useEffect(() => {
    if (!import.meta.env.DEV) return undefined;

    const onFocusIn = (event) => {
      const activeElement = document.activeElement;
      console.warn('[focus-debug]', {
        ts: new Date().toISOString(),
        target: describeFocusElement(event.target),
        activeElement: describeFocusElement(activeElement),
        relatedTarget: describeFocusElement(event.relatedTarget),
      });
    };

    document.addEventListener('focusin', onFocusIn, true);
    return () => document.removeEventListener('focusin', onFocusIn, true);
  }, []);
}

export { describeFocusElement };
